/**
 * @typedef {{
 *  name: string
 *  id: string
 *  description: string
 *  code: string
 *  categories: string[]
 *  tutorial?: string
 * }} chartMetadata
 */

/** @type string | null */
let prevChartIdRendered = null

/**
 * source: 'user_data' | 'sample_data' | 'template' | 'unknown'
 */
export function onChartRendered(chartMetadata, source = 'unknown') {
  if (prevChartIdRendered === chartMetadata.id) return
  prevChartIdRendered = chartMetadata.id

  if (typeof window.gtag === 'function') {
    window.gtag('event', 'chart_render', {
      event_category: chartMetadata.id,
      event_label: source,
    })
  }
}

export function onChartExported(chartMetadata, format) {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'chart-export', {
      event_category: chartMetadata.id,
      event_label: format,
    })
  }
}

export function onTemplateOpened(templateId, templateTitle) {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'template_open', {
      event_category: templateId,
      event_label: templateTitle,
    })
  }
}

export function onStepChanged(toStep, fromStep) {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'step_change', {
      event_category: toStep,
      event_label: fromStep,
    })
  }
}

export function onExportNudgeClicked(chartId) {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'export_nudge_clicked', {
      event_category: chartId,
    })
  }
}

/** Records a confirmed handoff from the Style workflow into Lugsail Labs. */
export function onLabsCanvasOpened(chartId, replacesWorkspace = false) {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'labs_canvas_opened', {
      chart_id: chartId,
      entry_point: 'style',
      replaces_workspace: replacesWorkspace,
    })
  }
}

export function onChartTypeSelected(chartId, chartName) {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'chart_type_selected', {
      event_category: chartId,
      event_label: chartName,
    })
  }
}

// response: 'yes' | 'not_yet' | 'missing'
// detail: free-text from "What's missing?" input, or null
export function onChartFeedback(chartId, response, detail = null) {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'chart_feedback', {
      event_category: chartId,
      event_label: response,
      ...(detail ? { value: detail.slice(0, 100) } : {}),
    })
  }
}
